import { Modal, Tabs } from 'antd'
import { PromoCodeItem } from 'Modules'
import { useEffect, useState } from 'react'

import { HistoryTab } from './history-tab'
import { SetupTab } from './setup-tab'

interface WhitelistEmailModalProps {
  open: boolean
  promoCode: PromoCodeItem | null
  canEdit: boolean
  onClose: () => void
}

/** "Whitelist & Email" popup — Setup (save whitelist + send email) and History tabs. */
export const WhitelistEmailModal = ({
  open,
  promoCode,
  canEdit,
  onClose,
}: WhitelistEmailModalProps) => {
  const [activeTab, setActiveTab] = useState('setup')

  useEffect(() => {
    if (open) setActiveTab('setup')
  }, [open, promoCode?.id])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={800}
      centered
      footer={null}
      destroyOnClose
      className="whitelist-email"
      title={
        <div className="whitelist-email__title">
          <div className="whitelist-email__title-main">Whitelist &amp; Email</div>
          <div className="whitelist-email__title-sub">{promoCode?.code}</div>
        </div>
      }
    >
      {/* Panes mount lazily and stay mounted so the Setup draft survives tab switches. */}
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'setup',
            label: 'Setup',
            children: <SetupTab promoCode={promoCode} canEdit={canEdit} onClose={onClose} />,
          },
          {
            key: 'history',
            label: 'History',
            children: <HistoryTab promoCode={promoCode} canEdit={canEdit} onClose={onClose} />,
          },
        ]}
      />
    </Modal>
  )
}
